//#region src/assets/gt-flag.svg
var gt_flag_default = "" + new URL("gt-flag-BZ8C4zWV.svg", import.meta.url).href;
//#endregion
export { gt_flag_default as default };

//# sourceMappingURL=gt-flag.js.map